import { Injectable } from '@angular/core';
import { HttpService } from '../../rest/http.service';
import { Observable } from 'rxjs';
import {Consider} from '../../models/consider';
import {UniversityList} from '../../models/university';

const routes = {
    consider: '/getChoiceInfo',
    university: '/api/customer/state',
    saveChoiceInfo: '/saveChoiceInfo',
    statelist : '/config/states?country=US',
   statelistWithCollege : '/api/customer/stateCodes',

};

@Injectable({
  providedIn: 'root'
})
export class ConsiderService {

   constructor(private httpService : HttpService) { }

  get() : Observable<Consider> {
		return this.httpService.get(routes.consider);
  }

  getUniversity(stateCode:string) : Observable<UniversityList> {
    if (stateCode == '-1') {
      return this.httpService.get(routes.university, 300);
    } else {
      return this.httpService.get(routes.university+'?statecode='+stateCode, 300);
    }
  }

  getStateList() : Observable<UniversityList> {
		return this.httpService.get(routes.statelist, 300);
  }
  getStateListWithCollege() : Observable<UniversityList> {
		return this.httpService.get(routes.statelistWithCollege, 300);
  }
  post(choiceInfo : any) : Observable<any> {
    return this.httpService.post(routes.saveChoiceInfo, choiceInfo);
  }
}
